export enum PackType {
    Pack = 'Pack',
    RePack = 'Repack',
}
